




















































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";

import {
  InvestmentCustodian,
  UserOnboardingStepKey
} from "@/shared/types";
import { BankCustodian } from "@/admin/types";
import OutageNotificationBanner from "@/shared/components/OutageNotificationBanner.vue";
import Notifier from "@/shared/components/Notifier.vue";
import AccountAlertPanel from "@/shared/components/accountAlert/AccountAlertPanel.vue";
import Header from "./shared/Header.vue";
import OnboardingHeader from "@/shared/components/OnboardingHeader.vue";
import HsaBankOnboardingHeader from "@/shared/components/HsaBankOnboardingHeader.vue";
import Nav from "@/employee/components/shared/Nav.vue";
import NavV2 from "@/employee/components/shared/NavV2.vue";
import HsabAdvancedNav from "@/employee/components/navBar/HsabAdvancedNav.vue";
import Footer from "@/employee/components/shared/Footer.vue";
import HsaBankFooterRoot from "@/employee/components/shared/HsaBankFooterRoot.vue";
import BankAccountClosedAlert from "@/employee/components/shared/BankAccountClosedAlert.vue";
import * as RouteNames from "@/employee/route-names";
import DatadogScript from "@/shared/components/DatadogScript.vue";
import {
  tint,
  shade,
  formatStyleString
} from "@/shared/colorAdjuster";
import FeedbackPrompt from "@/employee/components/FeedbackPrompt.vue";
import { useUserStore } from "@/shared/store/user";
import { useWizardStore } from "@/employee/store/wizard";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useThemeStore } from "@/shared/store/theme";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useNavigationStore } from "@/shared/store/navigation";
import router from "@/employee/routes";
import { useRootStore } from "@/shared/store/root";
import { hsabBankBalanceWatch } from "@/shared/hsabInvestmentBalanceWatch";
import { investmentThresholdStoreWatch } from "@/employee/investmentThresholdStoreWatch";
import { Route } from "vue-router";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { hsabLoginWatch } from "@/employee/loginWatch";
import ConsumerChatScript from "@/employee/components/shared/ConsumerChatScript.vue";
import _ from "lodash";
import Flagging from "@/shared/flagging";
import { useFdicStore } from "@/shared/store/fdic";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import * as HsaBankConstants from "@/shared/hsabConstants";

@Component({
  components: {
    Header,
    OnboardingHeader,
    HsaBankOnboardingHeader,
    Notifier,
    AccountAlertPanel,
    Nav,
    NavV2,
    Footer,
    HsaBankFooterRoot,
    HsaBankOnboardingFooter,
    DatadogScript,
    BankAccountClosedAlert,
    OutageNotificationBanner,
    HsabAdvancedNav,
    FeedbackPrompt,
    ConsumerChatScript
  }
})
export default class App extends Vue {
  rootStore = useRootStore();
  userStore = useUserStore();
  wizardStore = useWizardStore();
  advisorStore3 = useUserAdvisorStore();
  impersonatorStore = useImpersonatorStore();
  themeStore = useThemeStore();
  navigationStore = useNavigationStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  drivewealthStore = useDrivewealthStore();
  investmentStore = useInvestmentDailyBalanceStore();
  hsabAccountsStore = useHsabAccountsStore();
  portalCustomizationStore = usePortalCustomizationStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  fdicStore = useFdicStore();

  wizardStepNumber = 0;
  wizardStepKey: UserOnboardingStepKey = null;
  hideProgressIndicator = true;

  tint = tint;
  formatStyleString = formatStyleString;
  userName = "";
  phone = "";
  isUnloading = false;

  onBeforeUnload (event: BeforeUnloadEvent) {
    this.isUnloading = true;
  }

  beforeDestroy () {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    this.$root.$off("bv::modal::shown", this.applyModalTheme);
  }

  created () {
    this.rootStore.setupRoot();
    Flagging.initialize();
    window.addEventListener("beforeunload", this.onBeforeUnload);
    hsabLoginWatch();
    hsabBankBalanceWatch();
    investmentThresholdStoreWatch();

    this.registerActivity = _.throttle(this.registerActivity, 15000).bind(this);
    this.userStore.startAutologoutTimer();
    if (this.userStore.loggedIn && !this.isOktaSsoRoute && !this.isImpersonationInitiate) {
      this.redirectToWexIfWexOnlyAccount();
      this.userStore.refreshUser()
      .catch(_ => {
        if (this.isUnloading) {
          // when a fetch request is in process and the user refreshes the page,
          // the request is aborted, which triggers this catch block
          // prevent auto logout when the page is being refreshed. this flag isUnloading is being
          // set in onBeforeUnload
          return;
        }

        // if a user opens the app after the okta session has timed out and the app was closed without manually logging out,
        // the app shows the loading screen and the below OAuthError is logged in the cosole
        // OAuthError: The client specified not to prompt, but the user is not logged in
        // This forces the page to logout and reload which redirects users to the login page for credentials
        this.userStore.logout();
        window.location.reload();
      });
      this.featureFlagStore.setUserContext({
        email: this.userStore.email,
        partnerId: this.userStore.partnerId,
        employerId: this.userStore.employerId
      });
      if (this.isHsaBank) {
        this.hsabAccountsStore.getHsabAccounts();
      }
    }
  }

  get isLoaded (): boolean {
    return this.featureFlagStore.featureFlagsAvailable && this.isAnonymousOrIsCustodianSettingsLoaded();
  }

  isAnonymousOrIsCustodianSettingsLoaded (): boolean {
    return this.$route.meta.allowAnonymous || this.custodianSettingsStore.isLoaded;
  }

  mounted () {
    this.watchRoute(this.$route);

    // Modals are mounted in the DOM outside the <div id="app"> element, so the themeStore styling doesn't apply.
    // This handler ensures that the theme styling is applied to all modals.
    this.$root.$on("bv::modal::shown", this.applyModalTheme);
  }

  themedModals = [
    "lob-address-suggestion-modal",
    "onboarding-unsaved-changes"
  ];

  applyModalTheme (modalEvent: any) {
    if (!this.themeStore.colorStyle || !this.hasTargetStyle(modalEvent)) {
      return;
    }

    // For now, only apply the theme styling to the specified modals.
    // In the future, this check can be removed to apply the theme styling to all modals.
    if (this.themedModals.includes(modalEvent.componentId)) {
      modalEvent.target.style.cssText += `; ${this.themeStore.colorStyle}`;
    }
  }

  hasTargetStyle (modalEvent: any) {
    return modalEvent && modalEvent.target && modalEvent.target.style && modalEvent.target.style.cssText;
  }

  get isOktaSsoRoute () {
    return this.$route.name === RouteNames.OktaSso;
  }

  get isImpersonationInitiate () {
    return this.$route.name === RouteNames.InitiateImpersonation;
  }

  get isHsaBank () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }

  get useHsaBankFooter () {
    return (this.isHsaBank || this.custodianSettingsStore.userHsaCustodian === BankCustodian.Omnibus);
  }

  InitializeAdvisor () {
    if (this.mappedRouteName === null || !this.userStore.loggedIn) {
      return;
    }

    this.advisorStore3.loadAdvice3(this.mappedRouteName);
    this.advisorStore3.savePageViewEvent(this.mappedRouteName);
  }

  registerActivity () {
    this.userStore.activeUserPing();
  }

  get showOnboardingView () {
    return !this.userStore.userOnboarded
      && !this.wizardStore.isComplete
      && !this.impersonatorStore.impersonationIsStarting;
  }

  get showHsaBankOnboardingHeader () {
    return this.isHsaBank && !this.wizardStore.useClaimAccountFlow;
  }

  get isIndivdualSignupFlowView (): boolean {
    switch (this.$route.name) {
      case RouteNames.Signup:
      case RouteNames.LoginInfo:
      case RouteNames.SignupVerifyEmail:
        return true;
      default:
        return false;
    }
  }

  get isNamedOnboardingView (): boolean {
    return this.$route.name === RouteNames.NamedOnboarding;
  }

  get isOnboardingBalanceTransferView () {
    return this.$route.name === RouteNames.OnboardingBalanceTransfer;
  }

  get displayHsabBackgroundWrapper (): boolean {
    const partnerIdQueryValue = this.$route.query.partnerid || this.$route.query.partner;
    const partnerIdFromStore = this.portalCustomizationStore.partnerId;

    if (this.isIndivdualSignupFlowView) {
      // on individual signup view, use query param or default to HSAB Retail Partner
      const parsedPartnerId = _.toSafeInteger(partnerIdQueryValue || HsaBankConstants.HsaBankRetailPartnerId);
      return parsedPartnerId === HsaBankConstants.HsaBankRetailPartnerId;
    }

    // on all other pages, use query param, then portalCustomizationStore, then default to HSAB Retail Partner
    const parsedPartnerId = _.toSafeInteger(partnerIdQueryValue ||
        partnerIdFromStore || HsaBankConstants.HsaBankRetailPartnerId);
    return (this.isNamedOnboardingView || this.isOnboardingBalanceTransferView) &&
        parsedPartnerId === HsaBankConstants.HsaBankRetailPartnerId;
  }

  get hideHeader (): boolean {
    return this.$route.meta && this.$route.meta.hide_header === true;
  }

  get showHeader (): boolean {
    return this.isLoaded && !this.hideHeader;
  }
  get hideFooter () {
    return this.$route.meta && this.$route.meta.hide_footer === true;
  }

  get hideLeftNav () {
    return this.$route.meta && this.$route.meta.hide_left_nav === true;
  }

  get disableMinHeight () {
    return this.$route.meta && this.$route.meta.disable_min_height === true;
  }

  get addFdicBannerPadding () {
    return this.fdicStore.showFdic
      && !this.hideHeader
      && !this.showOnboardingView;
  }

  redirectToWexIfWexOnlyAccount () {
    if (this.hsabAccountsStore.isWexOnlyAccount) {
      this.$router.push({ name: RouteNames.WexRedirect });
    }
  }

  // This is dumb; refactor (partial refactor... this is still dumb...)`

  get mappedRouteName () {
    switch (this.$route.name) {
      case RouteNames.Home:
        return "Dashboard";
      case RouteNames.Dashboard:
        return "Dashboard";
      case RouteNames.InvestmentAccountInfo:
        return "InvestmentBalance";
      case RouteNames.HealthcareExpenses:
        return "HealthcareExpenses";
      case RouteNames.EligibleExpenses:
        return "HealthcareExpenses";
      case RouteNames.CashBalance:
        return "CashBalance";
      case RouteNames.AccountBalances:
        return "BalanceSummary";
      case RouteNames.Contribution:
        return "Contributions";
      case RouteNames.ContributionsAll:
        return "Contributions";
      case RouteNames.ReimburseMe:
        return "ReimburseMe";
      case RouteNames.ContributionPlanner:
        return "ContributionPlanner";
      case RouteNames.Resources:
        return "Resources";
      case RouteNames.Settings:
        return "Settings";
      case RouteNames.AccountsSummary:
        return "AccountSummary";
      default:
        return null;
    }
  }

  get shouldShowChat (): boolean {
    // Confirm with partner setting and flag value
    return this.userStore.loggedIn
    && this.featureFlagStore.flags.hsa5812ConsumerLiveChat
    && this.userStore.partnerConsumerLiveChatEnabled;
  }

  getRouteInformation (route: Route) {
    const stepParam = parseInt(route.params.step);
    this.wizardStepNumber = isNaN(stepParam) ? 0 : stepParam;

    // Investment pre-enrollment route is separate from the other wizard route and does not contain
    // stepKey as a param in the url. Manually set the stepKey here, instead.
    this.wizardStepKey = (route.name === RouteNames.OnboardingDrivewealthPreenrollment ?
      "investments" : route.params.stepKey) as UserOnboardingStepKey;

    this.hideProgressIndicator = route.name !== RouteNames.NamedOnboarding &&
      route.name !== RouteNames.OnboardingDrivewealthPreenrollment;
  }

  @Watch("$route")
  watchRoute (newRoute: Route) {
    if (newRoute && newRoute.fullPath) {
      this.getRouteInformation(newRoute);
      if (this.userStore.loggedIn) {
        this.userStore.loadPartnerSettings();
        // Attempt to retrieve partner support info each route change in case it hasn't been loaded yet, or the call
        // did not succeed previously.
        this.portalCustomizationStore.getSupportInfo(
          { partnerId: this.userStore.accountHolderPartnerId, employerId: this.userStore.accountHolderEmployerId });
        if (this.mappedRouteName !== null) {
          this.InitializeAdvisor();
        }
      }
      // User is not logged in -- make attempt to parse partner from query string to load partner support info
      else {
        const partnerIdQueryValue = this.$route.query.partnerid || this.$route.query.partner;
        const partnerIdFromStore = this.portalCustomizationStore.partnerId;
        let parsedPartnerId = 0;

        if (this.isIndivdualSignupFlowView) {
          // on individual signup view, use query param or default to HSAB Retail Partner
          parsedPartnerId = _.toSafeInteger(partnerIdQueryValue || HsaBankConstants.HsaBankRetailPartnerId);
          this.portalCustomizationStore.getUserLogo(parsedPartnerId);
        } else {
          // on all other pages, use query param, then portalCustomizationStore, then default to HSAB Retail Partner
          parsedPartnerId = _.toSafeInteger(partnerIdQueryValue ||
              partnerIdFromStore || HsaBankConstants.HsaBankRetailPartnerId);
        }

        this.portalCustomizationStore.getSupportInfo({ partnerId: parsedPartnerId, employerId: 0 });
      }
    }
  }

  @Watch("investmentThresholdStore.investmentProvider", { deep: true })
  watchInvestmentProviderSettings () {
    if (this.investmentThresholdStore.isDrivewealthInvestmentProvider) {
      this.drivewealthStore.loadAllowedInvestmentAccountTypes();
      this.investmentStore.loadCurrentDailyBalance();
      this.drivewealthStore.loadAccountIds({});
    }
  }

  @Watch("shouldShowChat")
  onShouldShowChange () {
     if (!this.shouldShowChat) {
       const chatWindow = document.getElementById("fn-chat-iframe-container");
       if (chatWindow) {
         chatWindow.remove();
       }
     }
   }
}
